// extracted by mini-css-extract-plugin
module.exports = {"card":"_2V8o6","row":"QWBKU","name":"_1c21q","shortDesc":"_2Zy1f","price":"_2Z1AA","specialPrice":"aJ90n","strikedPrice":"_12xl8"};